import React from "react";
import Navbars from "./Navbar/Navbars";
import Footer from "./Footers/Footer";

const Franchise = () => {
  return (
    <>
      <Navbars />
      <div>
        <img
          style={{ height: 625, width: 1348 }}
          src="./Images/franchisebg.jpg"
        />
        <img id="chatbot" src="./Images/chatbot.jpg"></img>
        <h1 id="franhead1">Franchise with knight bite</h1>
        <h3 id="franhead2">
          get started with the modern way of doing business
        </h3>
        <button id="franbtn">APPLY NOW</button>

        <h2 id="franhead3">Mission and Vision</h2>
        <br />
        <br />
        <br />
        <br />
        <br />
        <p id="franpara1">
          Our Mission is to deliver the best food
          <br /> with the ultimate customer service.
        </p>
        <br />
        <br />
        <br />
        <br />
        <br />
        <p id="franpara2">
          Our Vision is to be the most favourite <br />
          food chain brand in the country and world.
        </p>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <hr
          style={{
            height: 2,
            width: 1200,
            borderWidth: 2,
            color: "purple",
            backgroundColor: "purple",
          }}
        />
        <br />
        <h1 id="franhead4">Key Benefits Of Knight Bite Franchise</h1>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />

        <img src="./Images/franpic1.jpg" id="franpic1" />
        <img src="./Images/franpic2.jpg" id="franpic2" />
        <img src="./Images/franpic3.jpg" id="franpic3" />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <p id="franpicpara1">
          Anyone with basic training can step <br />
          into the shoes of the staff. <br />
          No serious training is required.
          <br /> Materials are sent.
        </p>
        <p id="franpicpara2">
          The hygiene, rent, staff and storage is the
          <br /> only maintenance the franchise
          <br /> would have to focus on.
        </p>
        <p id="franpicpara3">
          No need of prime roadside location, <br />
          interior decor. A office desk and any well hygenic
          <br /> kitchen space is enough
        </p>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <img src="./Images/franpic4.jpg" id="franpic4" />
        <img src="./Images/franpic5.jpg" id="franpic5" />
        <img src="./Images/franpic6.jpg" id="franpic6" />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <p id="franpicpara4">
          Knight Bite is the most successful business to run <br />
          hassle-free even during the Pandemic. The faith <br />
          in Knight Bite has taken a hit due to its high
          <br /> efficiency and extraordinary sustainability
        </p>
        <p id="franpicpara5">
          Establishment running cost is much lesser than
          <br /> traditional restaurant.
          <br />
          You are in for a good profit margin.
        </p>
        <p id="franpicpara6">
          POS will be provided to manage and track <br />orders with ease.All the
          applications are interconnected to the POS.Moreover call centre
          customer support will also be provided.
        </p>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
    
        <hr
          style={{
            height: 2,
            width: 1200,
            borderWidth: 2,
            color: "purple",
            backgroundColor: "purple",
          }}
        />
        <br /><br />

        <h1 id="franhead5">Apply here</h1>
        <p id="franhead6">Request for initial meeting</p>
        <img src="./Images/franmeetpic.jpg" id="franmeetpic" />
        <br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br />
        <br /><br /><br /><br /><br />
        <button id="franbtn2">APPLY NOW</button>
        <br /><br /><br />
        <br /><br />

        
        <hr
          style={{
            height: 2,
            width: 1200,
            borderWidth: 2,
            color: "purple",
            backgroundColor: "purple",
          }}
        />
         <br />
         <h1 id="franhead7">Franchise Queries</h1>
         <br /><br />

         <p id="querypara1">franchise@knight-bite.com</p>
         <img src="./Images/franquerypic1.jpg" id="franquerypic1" />

         <p id="querypara2">08047192034</p>
         <img src="./Images/franquerypic2.jpg" id="franquerypic2" />

         <p id="querypara3">Franchise Brochure</p>
         <img src="./Images/franquerypic3.jpg" id="franquerypic3" />
         
         <br /><br /><br /><br /><br /><br /><br />

         <Footer/>
        
      </div>
    </>
  );
};

export default Franchise;
